// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-gutters {\n  --bs-gutter-x: 0 !important;\n}\n.contact-users .contact-user {\n  margin-bottom: 0.625rem;\n}\n.contact-users .contact-user img {\n  height: 60px;\n  width: 60px;\n  margin-right: 0.625rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
